import {createFileRoute} from '@tanstack/react-router';
import SportDashboard from '../../../../sports/SportDashboard.tsx';
import {SPORT_AREAS} from '../../../../sports/sportAreas.ts';

export const Route = createFileRoute('/_app/cricket/dashboard/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <SportDashboard sport={SPORT_AREAS.cricket}/>
}
